
import { Suspense } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { IntegrationsHeader } from "@/components/integrations/IntegrationsHeader";
import { IntegrationsContainer } from "@/components/integrations/IntegrationsContainer";
import { ErrorBoundary } from "@/components/integrations/ErrorBoundary";

const Integrations = () => {
  return (
    <div className="space-y-8 max-w-full">
      <IntegrationsHeader />

      <ErrorBoundary fallback={<IntegrationsErrorFallback />}>
        <Suspense fallback={<IntegrationsLoadingSkeleton />}>
          <IntegrationsContainer />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
};

// Simple error fallback component
const IntegrationsErrorFallback = () => (
  <Card>
    <CardHeader>
      <CardTitle className="text-red-500">Erro ao Carregar Integrações</CardTitle>
      <CardDescription>
        Ocorreu um problema ao carregar os componentes de integração. Por favor, tente atualizar a página.
      </CardDescription>
    </CardHeader>
    <CardContent>
      <button 
        onClick={() => window.location.reload()}
        className="bg-primary text-primary-foreground px-4 py-2 rounded-md"
      >
        Recarregar Página
      </button>
    </CardContent>
  </Card>
);

// Loading skeleton for integrations
const IntegrationsLoadingSkeleton = () => (
  <div className="grid gap-6 animate-pulse">
    <Card className="h-[200px]">
      <CardHeader className="h-20 bg-gray-100 rounded-t-md"></CardHeader>
      <CardContent className="space-y-4 pt-6">
        <div className="h-8 bg-gray-100 rounded-md"></div>
        <div className="h-8 bg-gray-100 rounded-md"></div>
      </CardContent>
    </Card>
  </div>
);

export default Integrations;
